// src/constants.js
// API Base URL
const normalizeApiBase = (value) => {
  if (!value || typeof value !== 'string') return null;
  return value.replace(/\/$/, '');
};

const isLocalApi = (value) => /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(value || '');

const runtimeApiBase =
  typeof window !== 'undefined' && window._env_
    ? window._env_.REACT_APP_API_BASE_URL || window._env_.REACT_APP_API_URL
    : null;

const envApiBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL;
const originApiBase = typeof window !== 'undefined' ? window.location.origin : null;

const isLocalPage =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const safeRuntimeApiBase = !isLocalPage && isLocalApi(runtimeApiBase) ? null : runtimeApiBase;
const safeEnvApiBase = !isLocalPage && isLocalApi(envApiBase) ? null : envApiBase;

export const API_BASE_URL =
  normalizeApiBase(safeRuntimeApiBase) ||
  normalizeApiBase(originApiBase) ||
  normalizeApiBase(safeEnvApiBase) ||
  'https://cineart.top';

// 上传文件大小限制（100 MB，与服务端 Nginx / Multer 保持一致）
export const MAX_UPLOAD_SIZE = 100 * 1024 * 1024;
export const MAX_UPLOAD_SIZE_LABEL = '100MB';

export const TOOLBAR_BG = 'var(--toolbar-bg)'; // 深蓝主色调（令牌化：深色深蓝/浅色白）

// 连线颜色常量
export const EDGE_COLOR_MANUAL = '#b5a575'; 
export const EDGE_COLOR_AUTO = '#6b85a3'; 
export const EDGE_COLOR_SELECTED = '#ffffff'; 
export const EDGE_COLOR_TRANSMITTING = '#3b82f6'; 

// 连线类型颜色映射
export const TYPE_COLORS = {
  audio: '#10b981', // 青绿色
  video: '#8b5cf6', // 紫色
  image: '#3b82f6', // 蓝色
  text:  '#f59e0b', // 琥珀黄
  default: '#b5a575'
};

// 线宽与透明度常量
export const EDGE_WIDTH_IDLE = 1.5;    
export const EDGE_WIDTH_ACTIVE = 2.5;  
export const EDGE_WIDTH_NORMAL = 1.5;  

export const OPACITY_IDLE = 0.5;       
export const OPACITY_ACTIVE = 1.0;     

// --- 样式定义 ---
export const bottomContainerStyle = { position: 'absolute', bottom: '20px', left: '20px', zIndex: 10000, display: 'flex', alignItems: 'center', gap: '12px', pointerEvents: 'none' };
export const zoomCapsuleStyle = { background: 'var(--bg-panel)', border: '1px solid var(--border-subtle)', borderRadius: '30px', boxShadow: 'var(--shadow-panel)', display: 'flex', alignItems: 'center', pointerEvents: 'auto', overflow: 'hidden', height: '36px', padding: '0 4px' };
export const iconBtnStyle = { width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--text-secondary)', transition: 'all 0.1s', border: 'none', background: 'transparent' };
export const helpBtnStyle = { width: '36px', height: '36px', borderRadius: '50%', background: 'var(--bg-panel)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-panel)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--text-secondary)', pointerEvents: 'auto', transition: 'all 0.2s', position: 'relative' };
export const popoverStyle = { position: 'absolute', bottom: '48px', left: '0px', width: '180px', background: 'var(--bg-panel)', border: '1px solid var(--border-subtle)', borderRadius: '8px', boxShadow: 'var(--shadow-popover)', padding: '16px', color: 'var(--text-body)', fontFamily: 'system-ui, sans-serif', pointerEvents: 'auto', zIndex: 10001 };
export const keyBadgeStyle = { background: 'var(--badge-bg)', color: 'var(--badge-text)', borderRadius: '4px', padding: '1px 5px', fontSize: '11px', minWidth: '18px', textAlign: 'center', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'monospace', fontWeight: 'bold', lineHeight: '1.4', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' };
export const shortcutRowStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', fontSize: '12px', color: 'var(--text-secondary)' };
export const headerStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '8px', borderBottom: '1px solid var(--border-subtle)', fontSize: '13px', fontWeight: 'bold', color: 'var(--text-primary)' };

export const alertOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 20000, pointerEvents: 'none' };
export const alertBoxStyle = { background: 'var(--bg-panel)', padding: '24px 40px', borderRadius: '16px', border: '1px solid var(--border-subtle)', color: 'var(--text-primary)', pointerEvents: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.8)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', minWidth: '280px' };

// 【修改】背景色改为 TOOLBAR_BG (深蓝)，增加更强的阴影
export const contextMenuStyle = {
  position: 'fixed',
  background: 'var(--context-menu-bg)', // 深色深蓝/浅色深灰（比面板深，突出）
  border: '1px solid var(--border-strong)',
  borderRadius: '8px',
  padding: '6px',
  zIndex: 100000,
  boxShadow: '0 10px 40px rgba(0,0,0,0.8)', // 更深的阴影
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: '160px' //稍微宽一点，放下“上传素材”四个字
};

export const sidebarStyle = { position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', display: 'flex', flexDirection: 'column', gap: '8px', zIndex: 10000, background: TOOLBAR_BG, padding: '8px', borderRadius: '12px', border: '1px solid var(--border-subtle)', boxShadow: 'var(--sidebar-shadow)' };
export const sidebarBtnStyle = { background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px', borderRadius: '6px', transition: 'all 0.1s', color: 'var(--text-secondary)' };
export const sectionStyle = { display: 'flex', flexDirection: 'column', gap: '8px' };
export const menuContainerStyle = { position: 'fixed', width: '280px', background: 'var(--bg-panel-2)', borderRadius: '12px', border: '0.5px solid var(--border-strong)', padding: '10px', zIndex: 100000, boxShadow: '0 10px 40px rgba(0,0,0,0.6)' };
export const menuHeaderStyle = { fontSize: '10px', color: 'var(--text-muted)', marginBottom: '8px', paddingLeft: '4px', fontWeight: 'bold' };
export const menuListStyle = { display: 'flex', flexDirection: 'column', gap: '4px' };
export const menuItemStyle = { display: 'flex', alignItems: 'center', gap: '12px', padding: '10px', borderRadius: '8px', cursor: 'pointer', transition: 'all 0.2s' };
export const menuItemIconStyle = { color: 'var(--text-secondary)' };
export const menuItemContentStyle = { display: 'flex', flexDirection: 'column' };
export const menuItemTitleStyle = { fontSize: '12px', color: 'var(--text-primary)', fontWeight: 'bold' };
export const menuItemDescStyle = { fontSize: '10px', color: 'var(--text-muted)', lineHeight: '1.2' };